import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset! You can now log in.");
      navigate("/admind");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="reset-password-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm bg-[#0a0a0a] border border-white/10 rounded-2xl p-8">
        <h1 className="font-['Outfit'] font-bold text-xl mb-2">New Password</h1>
        <p className="text-zinc-500 text-sm mb-6">Set a new password with minimum 8 characters.</p>
        {token ? (
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="reset-password-form">
            <div className="space-y-2">
              <Label htmlFor="new-password" className="text-zinc-300">New Password</Label>
              <Input
                id="new-password" type="password" data-testid="new-password-input" minLength={8}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="bg-black/40 border-white/15 h-11 rounded-xl focus-visible:ring-[#A78BFA]" required
              />
            </div>
            <button
              type="submit" disabled={loading} data-testid="reset-submit-button"
              className="w-full rounded-full bg-[#A78BFA] text-black font-bold py-3 hover:bg-[#fbbf24] transition-colors active:scale-95 disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset Password
            </button>
          </form>
        ) : (
          <p className="text-sm text-red-400" data-testid="reset-no-token">Reset token is missing. Please use the link from your email.</p>
        )}
        <div className="mt-5 text-center">
          <Link to="/admind" className="text-xs text-zinc-500 hover:text-[#A78BFA] transition-colors" data-testid="reset-back-login">Back to login</Link>
        </div>
      </motion.div>
    </div>
  );
}
